export function initNavigation() {
  (function ($) {
    /**
     * Cache DOM Elements
     * Following DRY principle to avoid querying DOM repeatedly
     */
    const $window = $(window);
    const $body = $("body");
    const $shell = $("#navShell");
    const $menu = $("#mobileMenu");
    const $overlay = $("#overlay");
    const $openBtn = $("#mobile-menu-button");
    const $closeBtn = $("#closeMenu");

    /**
     * 1. Header Scroll Effect
     * Toggles .is-scrolled based on scroll position
     */
    function handleScroll() {
      // Only apply scroll effect if window is wide enough or simply apply globally based on design
      const isScrolled = $window.scrollTop() > 100;

      if (isScrolled) {
        $shell.addClass("is-scrolled");
        $body.addClass("nav-is-hidden");
      } else {
        $shell.removeClass("is-scrolled");
        $body.removeClass("nav-is-hidden");
      }
    }

    // Initialize and bind
    handleScroll();
    $window.on("scroll", handleScroll);

    /**
     * 2. Mobile Menu Sidebar Logic
     */
    function openMenu() {
      $menu.addClass("is-open");
      $overlay.addClass("is-active");
      $body.css("overflow", "hidden"); // Lock body scroll
    }

    function closeMenu() {
      $menu.removeClass("is-open");
      $overlay.removeClass("is-active");
      $body.css("overflow", ""); // Restore body scroll
    }

    $openBtn.on("click", function (e) {
      e.preventDefault();
      openMenu();
    });

    $closeBtn.on("click", function (e) {
      e.preventDefault();
      closeMenu();
    });

    $overlay.on("click", closeMenu);

    // Accessibility: Close on Escape key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $menu.hasClass("is-open")) {
        closeMenu();
      }
    });

    /**
     * 3. Mobile Submenu Accordion
     * Handles the chevron buttons generated by Ducon_Walker_Nav_Menu
     */
    $menu.on("click", ".nav__toggle", function (e) {
      e.preventDefault();

      const $btn = $(this);
      const $submenu = $btn.closest(".nav__item").find("> .nav__submenu");

      // Toggle the submenu
      $submenu.slideToggle(300);

      // Toggle visual state (rotation of icon)
      $btn.toggleClass("is-active");

      // Accessibility: Update aria-expanded
      const isExpanded = $btn.hasClass("is-active");
      $btn.attr("aria-expanded", isExpanded);
    });

    handleScroll();
  })(jQuery);
}
